'use client'

import { ReactElement } from 'react'

import { useTranslations } from 'next-intl'

import { useCookieConsent } from '@/context/CookieConsentContext'
import { Link } from '@/i18n/navigation'

import styles from './styles.module.scss'

export default function CookieConsent(): ReactElement | null {
    const { isReady, analyticsAllowed, acceptAnalytics } = useCookieConsent()
    const t = useTranslations('cookie')

    if (!isReady || analyticsAllowed) {
        return null
    }

    return (
        <div
            className={styles.banner}
            role={'dialog'}
            aria-live={'polite'}
            aria-label={t('ariaLabel')}
        >
            <div className={styles.content}>
                <p className={styles.title}>{t('title')}</p>
                <p className={styles.text}>
                    {t('text')}
                    <Link
                        href={'/legal/privacy-policy'}
                        className={styles.link}
                    >
                        {t('privacyPolicy')}
                    </Link>
                    {'.'}
                </p>
            </div>
            <div className={styles.actions}>
                <button
                    type={'button'}
                    className={styles.button}
                    onClick={acceptAnalytics}
                >
                    {t('accept')}
                </button>
            </div>
        </div>
    )
}
